/* Retailer page (page.retailers). The same page for every store: on submit, rolls the store fields
   (data-note) and the sample address (data-addr) into the Shopify customer note, one "Label: value" per line. */
(function(){
  document.querySelectorAll('[data-rt-form]').forEach(function(form){
    form.addEventListener('submit',function(){
      var lines=['Founding store reservation (retailer page)'];
      var seen={};
      form.querySelectorAll('[data-note]').forEach(function(el){
        if((el.type==='radio'||el.type==='checkbox')&&!el.checked)return;
        var label=el.getAttribute('data-note'),v=(el.value||'').trim();
        if(!v||seen[label])return;
        seen[label]=1;lines.push(label+': '+v);
      });
      var A={};form.querySelectorAll('[data-addr]').forEach(function(el){A[el.getAttribute('data-addr')]=(el.value||'').trim()});
      if(A.street){
        var addr=[A.street,A.unit,A.city,[A.state,A.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
        lines.push('Ship samples to: '+addr);
      }
      var note=form.querySelector('[data-rt-note]');if(note)note.value=lines.join('\n');
    });
  });

  // after a successful post, Shopify reloads the page; jump straight to the thank-you
  var done=document.querySelector('[data-rt-done]');
  if(done){done.scrollIntoView({block:'center'});done.focus({preventScroll:true})}
})();
